import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CartMatchDescription from './CartMatchDescription';
import CartMatchPrice from './CartMatchPrice';
import AddToOrderButton from './AddToOrderButton';
import {
    ITEM_TYPE_PRICE_LEVEL,
    ITEM_TYPE_BUNDLE,
    ITEM_TYPE_PRODUCT,
} from '../reducers/upsells';
import Translation from '@s/Translation';

/**
 * TODO translate
 */
class CartMatchOffer extends Component {

    static isValidDetail(detail) {
        const validTypes = [
            ITEM_TYPE_PRICE_LEVEL,
            ITEM_TYPE_BUNDLE,
            ITEM_TYPE_PRODUCT,
        ];
        if (typeof detail !== 'object' ||
            detail === null ||
            isNaN(detail.count) ||
            isNaN(detail.id) ||
            detail.count < 1 ||
            !validTypes.includes(detail.type))
        {
            return false;
        }
        return true;
    }

    render() {
        const priceComponent = <CartMatchPrice priceLevels={this.props.priceLevels} details={this.props.details} />;

        return(
            <div className="upsell__cart-match-offer">
                <div className="ticket ticket--cart-match">
                    <div className="ticket__information">
                        <div className="ticket__name">
                            <div>
                                <CartMatchDescription
                                    priceLevels={this.props.priceLevels}
                                    details={this.props.details}
                                />
                            </div>
                            <a className="event-info__description-toggle button--cart-match-change" onClick={this.props.onChangeTickets} disabled={this.props.loading}>
                                <Translation>{'checkout__change_tickets'}</Translation>
                            </a>
                        </div>
                        <div className="ticket__pricing-group hide-on-medium-screen">
                            {priceComponent}
                        </div>
                    </div>
                    <div className="ticket__pricing-group hide-on-small-screen">
                        {priceComponent}
                    </div>
                </div>
                {!this.props.isKioskMode &&
                    <div className='upsell__cart-match__footer'>
                        <AddToOrderButton onClick={this.props.onAccept} loading={this.props.loading} disabled={this.props.disabled}/>
                    </div>
                }
            </div>
        )
    }
}

CartMatchOffer.propTypes = {
    details: PropTypes.array.isRequired,
    onChangeTickets: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    priceLevels: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default CartMatchOffer;
